// GENERATED by scripts/i18n-gen.mjs from i18n/languages.json — DO NOT EDIT BY HAND.
// Edit i18n/languages.json and run `make i18n-gen`. `make ci` fails if this file is stale.
//
// The languages the Joana web shell is offered in (ADR-0028 D6). Track C had
// no i18n layer at all before this; the catalogue arrives first so the layer
// is built against the same list every other surface reads.

import enStrings from './strings.en.json' with { type: 'json' }
import swStrings from './strings.sw.json' with { type: 'json' }

export interface Language {
  /** BCP-47: ISO 639-1 where one exists, otherwise the ISO 639-3 subtag. */
  readonly tag: string
  /** The language's name in that language. What the picker shows. */
  readonly endonym: string
  /** The English name — for logs and ops, never for the picker. */
  readonly englishName: string
  /** Whether a picker may offer it (ADR-0028 D4). */
  readonly shipping: boolean
}

/** The base locale. A missing key falls back to it and never renders raw. */
export const BASE_LANGUAGE = 'en'

/** Every language, picker order, shipping and planned alike. */
export const LANGUAGES: readonly Language[] = [
  {
    tag: 'en',
    endonym: 'English',
    englishName: 'English',
    shipping: true,
  },
  {
    tag: 'sw',
    endonym: 'Kiswahili',
    englishName: 'Swahili',
    shipping: true,
  },
  {
    tag: 'zga',
    endonym: 'Kikinga',
    englishName: 'Kinga',
    shipping: false,
  },
]

/** The languages a picker may offer. Build the picker from THIS, not LANGUAGES. */
export const SHIPPING_LANGUAGES: readonly Language[] = LANGUAGES.filter((l) => l.shipping)

/** The language with this tag, or undefined if this build does not ship it. */
export function languageByTag(tag: string | null | undefined): Language | undefined {
  return LANGUAGES.find((l) => l.tag === tag)
}

/** Whether this tag may be stored as somebody's interface language. */
export function isOfferableLanguage(tag: string | null | undefined): boolean {
  return languageByTag(tag)?.shipping === true
}

/** One language's strings, keyed by the English sentence. */
export type Catalogue = Readonly<Record<string, string>>

/**
 * The strings this build carries, per language.
 *
 * Statically imported rather than fetched: a language that arrives one network
 * round-trip after the first paint is a page that visibly changes language
 * while you are reading it. They are small — the whole English catalogue is
 * smaller than one avatar.
 *
 * Generated from the SAME list the picker is built from. A tag that appears in
 * SHIPPING_LANGUAGES appears here, or this file does not compile.
 */
export const CATALOGUES: Readonly<Record<string, Catalogue>> = {
  'en': enStrings as Catalogue,
  'sw': swStrings as Catalogue,
}
